export default class User {
  id: number = -1;
  title: string = '';
  document: string = '';
  document_type: 'cpf' | 'cnpj' = 'cpf';
  email: string = '';
  phone: string = '';
  gifts: number = 0;
  lottery: boolean = false;
  zipcode: string = '';
  address: string = '';
  number: string = '';
  neighborhood: string = '';
  complement: string = '';
  state_id: number = -1;
  city_id: number = -1;
  state: string = '';
  city: string = '';
  soya: string = '0';
  corn: string = '0';
  sugarCane: string = '0';
  cotton: string = '0';
  wheat: string = '0';
  coffee: string = '0';
  citrus: string = '0';
  bean: string = '0';
  others: string = '0';

  constructor(obj?: {
    id: number;
    title: string;
    document: string;
    document_type: 'cpf' | 'cnpj';
    email: string;
    phone: string;
    gifts: number;
    lottery: boolean;
    zipcode: string;
    address: string;
    number: string;
    neighborhood: string;
    complement: string;
    state_id: number;
    city_id: number;
    state: string;
    city: string;
    soya: number;
    corn: number;
    sugarCane: number;
    cotton: number;
    wheat: number;
    coffee: number;
    citrus: number;
    bean: number;
    others: number;
  }) {
    if (obj !== undefined) {
      this.id = obj.id;
      this.title = obj.title;
      this.document = obj.document;
      this.document = obj.document_type;
      this.email = obj.email;
      this.phone = obj.phone;
      this.gifts = obj.gifts;
      this.lottery = obj.lottery;
      this.zipcode = obj.zipcode;
      this.address = obj.address;
      this.number = obj.number;
      this.neighborhood = obj.neighborhood;
      this.complement = obj.complement;
      this.state_id = obj.state_id;
      this.city_id = obj.city_id;
      this.state = obj.state;
      this.city = obj.city;
      this.soya = `${obj.soya}`;
      this.corn = `${obj.corn}`;
      this.sugarCane = `${obj.sugarCane}`;
      this.cotton = `${obj.cotton}`;
      this.wheat = `${obj.wheat}`;
      this.coffee = `${obj.coffee}`;
      this.citrus = `${obj.citrus}`;
      this.bean = `${obj.bean}`;
      this.others = `${obj.others}`;
    }
  }
}
